import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    currentCampaign: null,
    loading: false,
    loadingDetail: false,
    error: null,
    total: 0,
    detailTotal: 0,
    detailData: [],
    segments: [],
    selectedId: [],
});

const actions = {
    async campaignReadAll({ commit }, data) {
        try {
            commit('campaignReadAllBegin');
            const response = await DataService.get(`/campaigns?${new URLSearchParams(data).toString()}`);
            commit('campaignReadAllSuccess', response.data.data);
        } catch (err) {
            commit('campaignReadAllError', err);
        }
    },

    async campaignAdd({ commit }, payload) {
            commit('campaignAddBegin');
            await DataService.post('/campaigns', payload).then(response => {
                commit('campaignAddSuccess', response.data.data);

                notification.success({
                    message: response.data.message,
                    placement: 'topRight'
                });
            }).catch(err => {
                commit('campaignAddError', err);

                notification.error({
                    message: err.message,
                    placement: 'topRight'
                });
            });
    },

    async campaignRead({ commit }, id) {
        commit('campaignDetailReadBegin');

        await DataService.get(`/campaigns/${id}`).then(response => {
            commit('campaignReadSuccess', response.data.data);
        }).catch(err => {
            commit('campaignDetailReadError', err);
        });
    },

    async campaignDetailRead({ commit }, payload) {
        try {
            commit('campaignDetailReadBegin');
            payload.filters = payload.filters.length > 0 ? JSON.stringify(payload.filters) : [];
            const response = await DataService.get(`/campaigns/detail/${payload.id}?${new URLSearchParams(payload).toString()}`);
            commit('campaignDetailReadSuccess', response.data.data);
        } catch (err) {
            commit('campaignDetailReadError', err);
        }

    },

    addSelectedIds({ commit }, ids) {
        commit('setSelectedIds', ids);
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};